import React from "react";
import classNames from "classnames";
import { SectionTilesProps } from "../../utils/SectionProps";
import Image from "../elements/Image";

const propTypes = {
  ...SectionTilesProps.types,
};

const defaultProps = {
  ...SectionTilesProps.defaults,
};

const About = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "testimonial-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames(
    "tiles-wrap center-content",
    pushLeft && "push-left"
  );

  return (
    <section className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <Image
            className="title-image"
            src={require("./../../assets/images/TITLE_ABOUT_US.png")}
          />
          <p
            className="section-header center-content container-xs pm-0"
            style={{ color: "white" }}
          >
            At Paramo Games, we create games that aim to spark memorable emotions
          </p>
          <div className={tilesClasses}>
           
            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
<div
  className="tiles-item-inner"
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
  }}
>                <div className="features-tiles-item-header">
                  <h3 className="mt-0 mb-8" style={{ fontFamily: "Gilbert" }}>
                    VISION
                  </h3>
                </div>
                <p className="text-sm mb-0 border" style={{
  color: "white",
  border: "2px solid #2185cd",
  borderRadius: "18px",
  padding: "24px",
  minHeight: "240px",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  lineHeight: "1.7",
}}>
                  To become a leading game studio known for creating games 
                  that are unforgettable emotional experiences.
                </p>
              </div>
            </div>

            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
<div
  className="tiles-item-inner"
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
  }}
>                <div className="features-tiles-item-header">
                  <h3 className="mt-0 mb-8" style={{ fontFamily: "Gilbert" }}>
                    MISSION
                  </h3>
                </div>
                <p className="text-sm mb-0 border" style={{
  color: "white",
  border: "2px solid #2185cd",
  borderRadius: "18px",
  padding: "24px",
  minHeight: "240px",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  lineHeight: "1.7",
}}>
                  To create games that connect with people through meaningful experiences, 
                  they can enjoy as much as we enjoy making them.
                </p>
              </div>
            </div>

            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
<div
  className="tiles-item-inner"
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
  }}
>                <div className="features-tiles-item-header">
                  <h3 className="mt-0 mb-8" style={{ fontFamily: "Gilbert" }}>
                    VALUES
                  </h3>
                </div>
                <p className="text-sm mb-0 border" style={{
  color: "white",
  border: "2px solid #2185cd",
  borderRadius: "18px",
  padding: "24px",
  minHeight: "240px",
  width: "100%",
  textAlign: "center",
  lineHeight: "1.7",
}}>

                  <span style={{ color: "#2185cd" }}>Passion </span> in every project we develop.                 
                  <br />
                  <span style={{ color: "#2185cd" }}>Creativity </span> to create unique experiences.

                  <br />
                  <span style={{ color: "#2185cd" }}>Quality</span> and excellence in every detail.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className={innerClasses}>
          <Image
            src={require("./../../assets/images/TITLE_OUR_TEAM.png")}
            className="title-image"
          />

          <div className={tilesClasses}>
            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require("./../../assets/images/TEAM_ART.png")}
                      width={100}
                      height={100}
                    />
                  </div>

                  <h3 className="mt-0 mb-8" style={{ fontFamily: "Gilbert" }}>
                    ART
                  </h3>
                </div>
                <p className="text-sm mb-0" style={{ color: "white" }}>
                  UI / UX <br />
                  Concept Art
                  <br />
                  Key/Capsule Art, Icons
                  <br />
                  3D Character, Props, & Environments
                  <br />
                  3D & 2D Animation
                </p>
              </div>
            </div>
            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require("./../../assets/images/TEAM_PROGRAMMING.png")}
                      width={100}
                      height={100}
                    />
                  </div>
                  <h3 className="mt-0 mb-8" style={{ fontFamily: "Gilbert" }}>
                    ENGINEERING
                  </h3>
                </div>
                <p className="text-sm mb-0" style={{ color: "white" }}>
                  PC, Mobile, Web <br />
                  AR/VR Development <br />
                  Visualization & Simulation <br />
                  Online Networking <br />
                  Backend Services
                </p>
              </div>
            </div>

            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require("./../../assets/images/TEAM_GAME_DESIGN.png")}
                      width={100}
                      height={100}
                    />
                  </div>
                  <h3 className="mt-0 mb-8" style={{ fontFamily: "Gilbert" }}>
                    GAME DESIGN
                  </h3>
                </div>
                <p className="text-sm mb-0" style={{ color: "white" }}>
                  Design Consulting <br />
                  Narrative Design <br />
                  Level Design <br />
                  Environment Design & Implementation
                </p>
              </div>
            </div>

            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require("./../../assets/images/TEAM_VFX.png")}
                      width={100}
                      height={100}
                    />
                  </div>
                  <h3 className="mt-0 mb-8" style={{ fontFamily: "Gilbert" }}>
                    TECH ART
                  </h3>
                </div>
                <p className="text-sm mb-0" style={{ color: "white" }}>
                  VFX <br />
                  Particle Effects <br />
                  Shader Development <br />
                  Rigging
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className={innerClasses}>
          <p
            className="section-header center-content container-xs pm-0"
            style={{ color: "white" }}
          >
            We are happy to work with these technologies.
          </p>
          <div className={tilesClasses}>
            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require("./../../assets/images/SOFTWARE_1.png")}
                      width={400}
                      height={50}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require("./../../assets/images/SOFTWARE_2.png")}
                      width={100}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require("./../../assets/images/SOFTWARE_3.png")}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tiles-item reveal-from-bottom"
              data-reveal-delay="200"
            >
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require("./../../assets/images/SOFTWARE_4.png")}
                      width={80}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

About.propTypes = propTypes;
About.defaultProps = defaultProps;

export default About;
